'use strict';

/**
 * Form validation module that enables/disables submit buttons
 * based on whether all required form fields are complete
 */

// Auto-initialization of the form validation module
function initFormValidation() {

    const submitButtonSelector = '.submit-validation';
    
    $(submitButtonSelector).each(function () {
        const $submitButton = $(this);
        const $form = $submitButton.closest('form');
        
        if ($form.length) {
            // Disable the button initially
            $submitButton.prop('disabled', true);
            
            // Get all required fields within the form
            const $requiredFields = $form.find('input[required], select[required], textarea[required]');
            
            // If there are no required fields, enable the button
            if ($requiredFields.length === 0) {
                $submitButton.prop('disabled', false);
                return;
            }
            
            // Function to check if all required fields are complete
            function validateForm() {
                let allFieldsValid = true;
                
                $requiredFields.each(function () {
                    const $field = $(this);
                    const value = $field.val();
                    
                    // Check if the field is empty
                    if (!value || value.trim() === '') {
                        allFieldsValid = false;
                        return false;
                    }
                });
                
                // Enable or disable the button according to validation
                $submitButton.prop('disabled', !allFieldsValid);
            }
            
            // Validate on each change of any required field
            $requiredFields.on('input change', validateForm);
            
            validateForm();
        }
    });
}

module.exports = initFormValidation;
